/**
 * Created by TY-xie on 2018/3/21.
 */
export default class Sku {
  selectedSku = {};

  constructor(specList, skuList) {
	this.specList = [...specList];
	this.skuList = [...skuList];
	// 初始化selectedSku
	this.skuList.forEach(sku => {
	  sku.values = {};
	  sku.skuItems.forEach(i => sku.values[i.specGuid] = i.name);
	});
	specList.forEach(({guid}) => this.selectedSku[guid] = '');
  }

  // 对外暴露方法,设置某一项sku项目的值
  checkSpecItem(guid, value) {
	this.selectedSku[guid] = value;
  }

  // 根据传入的specGUID及spec值结合当前勾选状态查询该项是否可选
  isEnable(guid, value) {
	const model = {...this.selectedSku, [guid]: value};
	return this.emptyList.every(it => !isSame(it, model));
  }

  // 库存为0的数组(的sku详情){颜色GUID:red,尺寸GUID: xl}
  get emptyList() {
	return this.skuList.filter(it => it.inventoryNumber === 0).map(it => it.values);
  }

  // 所选商品的sku情况({颜色: red, 尺寸: xl})
  get specs() {
	if (this.filterList.length) {
	  let values = this.filterList[0].values;
	  let specs = {};
	  Object.keys(values).forEach(k => {
		let key = this.specList.find(({guid}) => guid === k).name;
		specs[key] = values[k];
	  });
	  return specs;
	}
	return null;
  }

  // 库存区间
  get inventory() {
	let ret = {
	  min: -1,
	  max: -1,
	};
	if (this.filterList.length === 1) {
	  return {
		min: this.filterList[0].inventoryNumber,
		max: this.filterList[0].inventoryNumber,
	  };
	}
	else {
	  // 限制数量的数组(-1为不限)
	  let limitList = this.filterList
		  .filter(it => it.inventoryNumber !== -1)
		  .map(({inventoryNumber}) => inventoryNumber);
	  // 所有项目均限制具体数量(不存在库存为-1的项目)
	  ret.min = Math.min(...limitList);
	  if (limitList.length === this.filterList.length) {
		ret.max = Math.max(...limitList);
	  }
	  else {
		// 存在库存为-1的项目,只需要找最小的库存
		ret.max = -1;
	  }
	}
	return ret;
  }

  // 价格区间
  get priceRange() {
	let priceRange = {
	  mall: {
		min: -1,
		max: -1,
	  },
	  market: {
		min: -1,
		max: -1,
	  },
	};
	let {mall, market} = priceRange;
	this.filterList.forEach(({mallPrice, marketPrice}) => {
	  if (mall.min < 0) {
		mall.min = mall.max = mallPrice;
		market.min = market.max = marketPrice;
	  }
	  else {
		if (mallPrice < mall.min) {
		  mall.min = mallPrice;
		}
		else if (mallPrice > mall.max) {
		  mall.max = mallPrice;
		}
		if (marketPrice < market.min) {
		  market.min = marketPrice;
		}
		else if (marketPrice > market.max) {
		  market.max = marketPrice;
		}
	  }
	});
	return priceRange;
  }

  // 随着selected Sku变化而筛选的数组,所有sku项均勾选的情况应只有一个
  get filterList() {
	// 筛选一个数组,该数组包含了当前用户所选择的skuName
	return this.skuList.filter(it => isSame(it.values, this.selectedSku));
  }

  // 用于展示的sku项的数组,其属性决定该项状态
  get displayList() {
	// 用户所选择的sku Name的数组
	return this.specList.map(({guid, name, values}) => {
	  /*	  let list = [];
			values.forEach(v => {
			  list.push({
				guid,
				text: v,
				enable: this.isEnable(guid, v),
				check: this.selectedSku[guid] === v
			  });
			});*/
	  const list = values.map(it => ({
		guid,
		text: it,
		enable: this.isEnable(guid, it),
		check: this.selectedSku[guid] === it
	  }));

	  return {
		list,
		guid,
		name,
	  };
	});
  }
}

function isSame(A, B) {
  if (Object.keys(A).length !== Object.keys(B).length) return false;
  return Object.keys(A).every(key => B[key] === A[key]);
}
